import { z } from 'zod';

export const createProjectSchema = z.object({
  customerId: z.string().uuid('Bitte einen Kunden auswählen.'),
  objectId: z.string().uuid('Bitte ein Objekt auswählen.'),
  title: z.string().min(3, 'Bitte einen Titel eingeben.').max(160),
  description: z.string().max(2000).optional().or(z.literal('')),
  scopeOriginal: z.string().max(4000).optional().or(z.literal('')),
  plannedStart: z.string().optional().or(z.literal('')),
  plannedEnd: z.string().optional().or(z.literal('')),
});
export type CreateProjectValues = z.infer<typeof createProjectSchema>;
